import * as bs58 from 'bs58';
import { VersionedTransaction } from '@solana/web3.js';

export const parseTransaction = (unsignedTx: string) => {
  const txUint8Array = bs58.decode(unsignedTx);
  return VersionedTransaction.deserialize(txUint8Array);
};
